<template>
  <div>
    <nav class="pagination" role="navigation" aria-label="pagination">
      <button @click="prevClick" class="pagination-previous" :disabled="currentPage === 1">Назад</button>
      <button @click="nextClick" rel="next" class="pagination-next" :disabled="currentPage === totalPages">Вперед</button>
      <ul class="pagination-list">
        <li v-for="n in totalPages" :key="n">
          <a @click="clickCallback(n)" class="pagination-link" :class="n === currentPage ? 'is-current' : ''">{{ n }}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "PaginationComponent.vue",
  props: [
    'perPage',
    'totalItems',
    'currentPageNum'
  ],
  data() {
    return {
      currentPage: this.currentPageNum
    }
  },
  computed: {
    totalPages: function() {
      return Math.ceil(this.totalItems/this.perPage)
    },
  },
  methods: {
    clickCallback(pageNum) {
      this.currentPage = pageNum;
    },
    nextClick() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevClick() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    }
  },
  watch: {
    currentPage() {
      this.$emit("updateParentData", this.currentPage);
    }
  }
}
</script>

<style scoped>

</style>